import type { Column } from "@tanstack/react-table";
import { useTranslation } from "react-i18next";

import { DateInput } from "../../date-input";

import { DebouncedInput } from "./debounced-input";
import { SimpleSelect } from "./simple-select";

/**
 * Ustun sarlavhasidagi filtr.
 *
 * Qaysi boshqaruv chizilishi ustunning `meta.filterVariant` iga bog'liq —
 * jadval komponenti filtrlar ro'yxatini bilmaydi va bilishi ham shart
 * emas. Yangi ustun qo'shilganda faqat `meta` yoziladi.
 */
export function Filters<TData>({ column }: Readonly<{ column: Column<TData, unknown> }>) {
  const { t } = useTranslation();

  const meta = column.columnDef.meta;
  const value = column.getFilterValue();

  switch (meta?.filterVariant) {
    case "text":
      return (
        <DebouncedInput
          type="text"
          placeholder={t("common.search")}
          value={typeof value === "string" ? value : ""}
          onChange={next => column.setFilterValue(next || undefined)}
        />
      );

    // Sana `text` dan alohida: yarim yozilgan sana bilan qidirish
    // ro'yxatni behuda tozalardi, va `DD.MM.YYYY` qolipini har bir
    // ustunda qaytadan tushuntirib bo'lmaydi.
    case "date":
      return (
        <DateInput
          autoFocus
          withTime={meta.dateWithTime}
          value={typeof value === "string" ? value : ""}
          onCommit={next => column.setFilterValue(next || undefined)}
        />
      );

    case "select":
      return meta.filterOptions ? (
        <SimpleSelect
          value={typeof value === "string" ? value : undefined}
          onChange={next => column.setFilterValue(next)}
          options={meta.filterOptions}
        />
      ) : null;

    default:
      return null;
  }
}
